/** Suppress session-expiry logout briefly after OAuth / login (popup focus races on web). */
const DEFAULT_MS = 12_000;

let recentAuthAt = 0;

export function markRecentAuthSuccess(): void {
  recentAuthAt = Date.now();
}

export function clearAuthGracePeriod(): void {
  recentAuthAt = 0;
}

export function isWithinAuthGracePeriod(ms: number = DEFAULT_MS): boolean {
  return recentAuthAt > 0 && Date.now() - recentAuthAt < ms;
}
